import fullLogo from "../apps/logo/full.svg";
import responsiveLogo from "../apps/logo/responsive.svg";

const brand = {
  name: process.env.REACT_APP_BRAND_NAME || "Roombelt",
  fullName: process.env.REACT_APP_BRAND_FULL_NAME || "Roombelt Mateusz Zieliński",
  websiteUrl: process.env.REACT_APP_WEBSITE_URL || "https://roombelt.com",
  helpUrl: process.env.REACT_APP_HELP_URL || "https://go.roombelt.com/help",
  termsUrl: process.env.REACT_APP_TERMS_URL || "https://roombelt.com/terms-and-conditions",
  privacyUrl: process.env.REACT_APP_PRIVACY_URL || "https://roombelt.com/privacy-policy",
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || "mateusz@roombelt.com",
  primaryColor: process.env.REACT_APP_PRIMARY_COLOR || "#467fcf",
  primaryColorHover: process.env.REACT_APP_PRIMARY_COLOR_HOVER || "#316cbe",
  logoFullUrl: process.env.REACT_APP_LOGO_FULL_URL || fullLogo,
  logoResponsiveUrl: process.env.REACT_APP_LOGO_RESPONSIVE_URL || responsiveLogo,
  setupGuideUrl: process.env.REACT_APP_SETUP_GUIDE_URL || "https://go.roombelt.com/UgIpHu",
  googleCalendarHelpUrl: process.env.REACT_APP_GOOGLE_CALENDAR_HELP_URL || "https://go.roombelt.com/scMpEB",
  office365CalendarHelpUrl: process.env.REACT_APP_OFFICE365_CALENDAR_HELP_URL || "https://go.roombelt.com/x1hoy5",
};

export default brand;
